(function(d) {
  'use strict';

  $('.nav-search-open-button').click(function(e) {
    e.preventDefault();
    $('.header__content').addClass('header__content--search-visible');
    $('.header__content .nav-search__keywords').select().focus();
  });
  $('.nav-search-close-button').click(function(e) {
    e.preventDefault();
    $('.header__content').removeClass('header__content--search-visible');
  });

})(document);